
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/earn",
      function () {
        return require("private-next-pages/earn.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/earn"])
      });
    }
  